import { render, staticRenderFns } from "./AdminInboundDeliveryList.vue?vue&type=template&id=4bf92602&scoped=true"
import script from "./AdminInboundDeliveryList.vue?vue&type=script&lang=js"
export * from "./AdminInboundDeliveryList.vue?vue&type=script&lang=js"
import style0 from "./AdminInboundDeliveryList.vue?vue&type=style&index=0&id=4bf92602&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf92602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf92602')) {
      api.createRecord('4bf92602', component.options)
    } else {
      api.reload('4bf92602', component.options)
    }
    module.hot.accept("./AdminInboundDeliveryList.vue?vue&type=template&id=4bf92602&scoped=true", function () {
      api.rerender('4bf92602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbound/AdminInboundDeliveryList.vue"
export default component.exports